<template>
  <transition type="animation" appear enter-active-class="animate__animated animate__fadeIn" mode="out-in">
    <div v-if="temPermissao('banco-de-livros')" class="main pb-4" id="about-main">
      <b-container fluid="lg">
        <b-card no-body class="shadow-sm card_sistemacpv p-4">
          <b-row>
            <b-col cols="12" class="mt-1 mb-1" v-for="(material, index) in lists" :key="index">
              <b-link :href="material.LinkFree">
                <b-card no-body class="p-3 card_sistemacpv border-light">
                  <div class="d-flex align-items-center">
                    <i class="fa-light fa-book fa-xl mr-2"></i>
                    <span>{{ material.title }}</span>
                  </div>
                </b-card>
              </b-link>
            </b-col>
          </b-row>
        </b-card>
      </b-container>
    </div>
    <div v-else>
      <div class="container">
        <div class="text-center">
          {{ error503 }}
          <p>Você não tem permissão para visualizar este conteúdo.</p>
        </div>
      </div>
    </div>
  </transition>
</template>

  <script>  
export default {
  data() {
    return {
      pageTitle: 'Banco de Livros',
      pageSubtitle: 'Ensino Fundamental I - 1º Ano',
      NamePermission: '',
      IndexPermission: '',
      lists: [
        {
          linkReaOnly: '',
          LinkFree: 'https://app-sistemacpv.s3.amazonaws.com/pdf/pdf_read_free/fundamental_1-1-ano/voz_dos_animais.pdf',
          videoId: '',
          src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/infantil/base-banco-livros-fund1.png',
          bundle: 'books',
          title: 'Voz dos Animais',
          segment: '1',
          discipline: 'Voz dos Animais',
          description: 'Ensino Fundamental I',
          toolTip: ' ',
          anoSerie: 'Série Poesia 1º ano',
        },
        {
          linkReaOnly: '',
          LinkFree: 'https://app-sistemacpv.s3.amazonaws.com/pdf/pdf_read_free/fundamental_1-1-ano/trava_lingua.pdf',
          videoId: '',
          src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/infantil/base-banco-livros-fund1.png',
          bundle: 'books',
          title: 'Trava-Línguas',
          segment: '1',
          discipline: 'Trava-Línguas',
          description: 'Ensino Fundamental I',
          toolTip: ' ',
          anoSerie: 'Série Poesia - 1º ano',
        },
        {
          linkReaOnly: '',
          LinkFree: 'https://app-sistemacpv.s3.amazonaws.com/pdf/pdf_read_free/fundamental_1-1-ano/passaro_cativo.pdf',
          videoId: '',
          src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/infantil/base-banco-livros-fund1.png',
          bundle: 'books',
          title: 'O Pássaro Cativo',
          segment: '1',
          discipline: 'O Pássaro Cativo',
          description: 'Ensino Fundamental I',
          toolTip: ' ',
          anoSerie: 'Série Poesia - 1º ano',
        },
        {
          linkReaOnly: '',
          LinkFree:
            'https://app-sistemacpv.s3.amazonaws.com/pdf/pdf_read_free/fundamental_1-1-ano/o_rei_e_a_flauta.pdf',
          videoId: '',
          src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/infantil/base-banco-livros-fund1.png',
          bundle: 'books',
          title: 'O Rei e a Flauta',
          segment: '1',
          discipline: 'O Rei e a Flauta',
          description: 'Ensino Fundamental I',
          toolTip: ' ',
          anoSerie: 'Série Ficção - 1º ano',
        },
        {
          linkReaOnly: '',
          LinkFree: 'https://app-sistemacpv.s3.amazonaws.com/pdf/pdf_read_free/fundamental_1-1-ano/o_patinho_feio.pdf',
          videoId: '',
          src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/infantil/base-banco-livros-fund1.png',
          bundle: 'books',
          title: 'O Patinho Feio',
          segment: '1',
          discipline: 'O Patinho Feio',
          description: 'Ensino Fundamental I',
          toolTip: ' ',
          anoSerie: 'Série Ficção - 1º ano',
        },
        {
          linkReaOnly: '',
          LinkFree:
            'https://app-sistemacpv.s3.amazonaws.com/pdf/pdf_read_free/fundamental_1-1-ano/o_passaro_encantado.pdf',
          videoId: '',
          src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/infantil/base-banco-livros-fund1.png',
          bundle: 'books',
          title: 'O Pássaro Encantado',
          segment: '1',
          discipline: 'O Pássaro Encantado',
          description: 'Ensino Fundamental I',
          toolTip: ' ',
          anoSerie: 'Série Ficção - 1º ano',
        },
        {
          linkReaOnly: '',
          LinkFree:
            'https://app-sistemacpv.s3.amazonaws.com/pdf/pdf_read_free/fundamental_1-1-ano/o-marques-de-rabico-Monteiro-Lobato.pdf',
          videoId: '',
          src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/infantil/base-banco-livros-fund1.png',
          bundle: 'books',
          title: 'O Marquês de Rabicó',
          segment: '1',
          discipline: 'O Marquês de Rabicó',
          description: 'Ensino Fundamental I',
          toolTip: ' ',
          anoSerie: 'Série Ficção - 1º ano',
        },
        {
          linkReaOnly: '',
          LinkFree: 'https://app-sistemacpv.s3.amazonaws.com/pdf/pdf_read_free/fundamental_1-1-ano/joao_de_barro.pdf',
          videoId: '',
          src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/infantil/base-banco-livros-fund1.png',
          bundle: 'books',
          title: 'João-de-Barro',
          segment: '1',
          discipline: 'João-de-Barro',
          description: 'Ensino Fundamental I',
          toolTip: ' ',
          anoSerie: 'Série Ficção - 1º ano',
        },
        {
          linkReaOnly: '',
          LinkFree:
            'https://app-sistemacpv.s3.amazonaws.com/pdf/pdf_read_free/fundamental_1-1-ano/balu-e-bela-jane-prado.pdf',
          videoId: '',
          src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/infantil/base-banco-livros-fund1.png',
          bundle: 'books',
          title: 'Balu e Bela',
          segment: '1',
          discipline: 'Balu e Bela',
          description: 'Ensino Fundamental I',
          toolTip: ' ',
          anoSerie: 'Série Ficção  - 1º ano',
        },
        {
          linkReaOnly: '',
          LinkFree:
            'https://app-sistemacpv.s3.amazonaws.com/pdf/pdf_read_free/fundamental_1-1-ano/a_ultima_formiga.pdf',
          videoId: '',
          src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/infantil/base-banco-livros-fund1.png',
          bundle: 'books',
          title: 'A última formiga',
          segment: '1',
          discipline: 'A última formiga',
          description: 'Ensino Fundamental I',
          toolTip: ' ',
          anoSerie: 'Série Ficção  - 1º ano',
        },
        {
          linkReaOnly: '',
          LinkFree:
            'https://app-sistemacpv.s3.amazonaws.com/pdf/pdf_read_free/fundamental_1-1-ano/a_princesa_e_a_ervilha.pdf',
          videoId: '',
          src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/infantil/base-banco-livros-fund1.png',
          bundle: 'books',
          title: 'A Princesa e a Ervilha',
          segment: '1',
          discipline: 'A Princesa e a Ervilha',
          description: 'Ensino Fundamental I',
          toolTip: ' ',
          anoSerie: 'Série Ficção  - 1º ano',
        },
        {
          linkReaOnly: '',
          LinkFree:
            'https://app-sistemacpv.s3.amazonaws.com/pdf/pdf_read_free/fundamental_1-1-ano/a_menina_do_narizinho_arrebitado_Monteiro_Lobato.pdf',
          videoId: '',
          src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/infantil/base-banco-livros-fund1.png',
          bundle: 'books',
          title: 'A Menina do Narizinho Arrebitado',
          segment: '1',
          discipline: 'A Menina do Narizinho Arrebitado',
          description: 'Ensino Fundamental I',
          toolTip: ' ',
          anoSerie: 'Série Ficção  - 1º ano',
        },
        {
          linkReaOnly: '',
          LinkFree:
            'https://app-sistemacpv.s3.amazonaws.com/pdf/pdf_read_free/fundamental_1-1-ano/a_cegonha_e_a_raposa.pdf',
          videoId: '',
          src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/infantil/base-banco-livros-fund1.png',
          bundle: 'books',
          title: 'A Cegonha e a Raposa',
          segment: '1',
          discipline: 'A Cegonha e a Raposa',
          description: 'Ensino Fundamental I',
          toolTip: ' ',
          anoSerie: 'Série Ficção  - 1º ano',
        },
        {
          linkReaOnly: '',
          LinkFree: 'ensino-fundamental-1/manual/1-ano/clifford-o-cachorrao-vermelho.pdf',
          videoId: '',
          src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/tbw_manual_professor.png',
          bundle: 'F_FUND1',
          title: 'Clifford o Cachorrao Vermelho',
          segment: '1',
          discipline: '',
          description: '',
          toolTip: '',
          isbn: 'Book',
        },
        {
          linkReaOnly: '',
          LinkFree: 'ensino-fundamental-1/manual/1-ano/clifford-o-filhotinho-vermelho.pdf',
          videoId: '',
          src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/tbw_manual_professor.png',
          bundle: 'F_FUND1',
          title: 'Clifford o Filhotinho Vermelho',
          segment: '1',
          discipline: '',
          description: '',
          toolTip: '',
          isbn: 'Book',
        },
        {
          linkReaOnly: '',
          LinkFree: 'ensino-fundamental-1/manual/1-ano/rita_sapeca.pdf',
          videoId: '',
          src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/tbw_manual_professor.png',
          bundle: 'F_FUND1',
          title: 'Rita Sapeca de Férias',
          segment: '1',
          discipline: '',
          description: '',
          toolTip: '',
          isbn: 'Book',
        },
      ],
    };
  },

  created() {
    this.$emit('update-header', {
      title: this.pageTitle,
      subtitle: this.pageSubtitle,
    });
  },

  computed: {
    permissions() {
      return this.$store.state.auth.userpermissions.permissions;
    },
    error503() {
      return (window.location.href = '/nao-autorizado');
    },
  },

  methods: {
    temPermissao(permissao) {
      return this.permissions.includes(permissao);
    },
    formatParam(param) {
      return param.replace(/\s+/g, '-');
    },
  },
};
</script>

 <style scoped> 
.main {
  margin-top: 30px;
}

.card_sistemacpv {
    border-radius: 8px;
    color: #3A1C53;
}
</style>